import { render } from "./comprehensiveForm.vue?vue&type=template&id=4070a482&scoped=true"
import script from "./comprehensiveForm.vue?vue&type=script&lang=js"
export * from "./comprehensiveForm.vue?vue&type=script&lang=js"

import "./comprehensiveForm.vue?vue&type=style&index=0&id=4070a482&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4070a482"],['__file',"src/views/vab/form/comprehensiveForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4070a482"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4070a482', __exports__)) {
    console.log('reload')
    api.reload('4070a482', __exports__)
  }
  
  module.hot.accept("./comprehensiveForm.vue?vue&type=template&id=4070a482&scoped=true", () => {
    console.log('re-render')
    api.rerender('4070a482', render)
  })

}


export default __exports__